"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableDatesForCalendar = getAvailableDatesForCalendar;
exports.getSelectedDatesForCalendar = getSelectedDatesForCalendar;
exports.getValidStartsForPackage = getValidStartsForPackage;
exports.getDatesOnDateSelect = getDatesOnDateSelect;
exports.filterDateForCalendar = filterDateForCalendar;
exports.hasConsecutiveAvailability = hasConsecutiveAvailability;
exports.getUTCNoon = getUTCNoon;
// TODO remove eslint disable comments
const date_fns_1 = require("date-fns");
// Get open dates with enough slots for the guest count selected
function getAvailableDatesForCalendar(availabilityList, totalGuests) {
    return availabilityList
        .filter((availability) => {
        const isFuture = availability.date >= Date.now();
        const hasEnoughSlots = availability.available_slots - totalGuests >= 0;
        return isFuture && hasEnoughSlots && availability.is_available;
    })
        .sort((availabilityL, availabilityR) => availabilityL.date - availabilityR.date)
        .map((availability) => new Date(availability.date));
}
// Get selected dates to highlight in calendar once a
// date / date range has been selected
function getSelectedDatesForCalendar(startDate, endDate) {
    const dates = [startDate, endDate].filter(Boolean);
    // If it's a single date, return it
    if (dates.length < 2)
        return dates;
    return (0, date_fns_1.eachDayOfInterval)({ end: dates[1], start: dates[0] }).map((date) => new Date(getUTCNoon(date)));
}
// Get the valid options for choosing a start day for a SET_DAY package
function getValidStartsForPackage(availableDates, pricingPackageDaysIncluded) {
    if (!pricingPackageDaysIncluded)
        return [];
    return availableDates.filter((startDate) => {
        const endDate = (0, date_fns_1.addDays)(startDate, pricingPackageDaysIncluded - 1);
        const interval = { end: endDate, start: startDate };
        return hasConsecutiveAvailability(interval, availableDates);
    });
}
// Handler for date picker select
function getDatesOnDateSelect(dates, pricingPackage) {
    const datesForSelect = dates.filter(Boolean);
    const { pricingPackageDaysIncluded, pricingPackageIsSetDay } = pricingPackage;
    if (pricingPackageIsSetDay) {
        if (!datesForSelect[0])
            throw new Error("dates[0] must be set");
        const endDate = pricingPackageDaysIncluded > 1
            ? (0, date_fns_1.addDays)(datesForSelect[0], pricingPackageDaysIncluded - 1)
            : datesForSelect[0];
        return [datesForSelect[0], endDate];
    }
    return datesForSelect;
}
// Helper for the filterDate prop of the React Datepicker
function filterDateForCalendar(date, { availableDates, selectedDates, }) {
    // Date used for filterDate   : 2023-08-18 00:00:00 GMT (at start)
    // Available dates to compare : 2023-08-18 12:00:00 UTC (at noon)
    const noon = getUTCNoon(date);
    if (!selectedDates[0])
        throw new Error("selectedDates[] must not be empty");
    const firstSelDt = selectedDates[0] || noon;
    // TODO can we remove the `as [Date | number, Date | number]`?
    const [start, end] = [firstSelDt, noon].sort(date_fns_1.compareAsc);
    const interval = { end, start };
    return hasConsecutiveAvailability(interval, availableDates);
}
function hasConsecutiveAvailability(interval, availableDates) {
    const { end, start } = interval;
    // Dates available for comparison are converted to UTC
    // Noon, e.g., 2023-08-18 12:00:00 UTC (at noon)
    // Convert other dates to the same UTC Noon for accurate comparison
    const startUtcNoon = getUTCNoon(start);
    const endUtcNoon = getUTCNoon(end);
    let nextDt = startUtcNoon;
    // eslint-disable-next-line no-loops/no-loops
    while ((0, date_fns_1.isBefore)(nextDt, endUtcNoon) || (0, date_fns_1.isEqual)(nextDt, endUtcNoon)) {
        // eslint-disable-next-line @typescript-eslint/no-loop-func
        const isDateAvailable = availableDates.some((date) => (0, date_fns_1.isSameDay)(date, nextDt));
        if (!isDateAvailable) {
            return false;
        }
        nextDt = (0, date_fns_1.addDays)(nextDt, 1);
    }
    return true;
}
function getUTCNoon(date) {
    const temporaryDate = new Date(date);
    const month = 12;
    return new Date(Date.UTC(temporaryDate.getFullYear(), temporaryDate.getMonth(), temporaryDate.getDate(), month, 0, 0));
}
